/** @format */

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import * as React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useApiFeedback } from "../../app/useApiFeedback";
import MessageResponse from "../feedback/messageResponse";
import { selectAdmin } from "../../features/admin/adminSlice";
import { fetchAllApplicantThunk, fetchDashboardThunk } from "../../features/admin/thunks";

export enum TypeOfRequest {
  AllApplications,
  LoadDashboard,
}
interface Props {
  request: TypeOfRequest;
  onYearChange?: (year: number) => void;
  selectedYear?: number;
  disabled?: boolean;
}
export default function ApplicationYear({ 
  request, 
  onYearChange, 
  selectedYear: propSelectedYear, 
  disabled = false 
}: Props) {
  const adminSelect = useAppSelector(selectAdmin) as any;
  const dispatch = useAppDispatch();
  const { feedback, handleApiResponse } = useApiFeedback();
  const [internalSelected, setInternalSelected] = React.useState<number>(
    propSelectedYear ?? new Date().getFullYear()
  );

  React.useEffect(() => {
    if (propSelectedYear !== undefined) {
      setInternalSelected(propSelectedYear);
    }
  }, [propSelectedYear]);

  const handleYearChange = (e: SelectChangeEvent<string>) => {
    const val = Number(e.target.value);
    if (!Number.isFinite(val)) {
      return;
    }

    setInternalSelected(val);
    onYearChange?.(val);

    // Parent may already load (e.g. Dashboard); avoid duplicate requests and races.
    if (onYearChange === undefined) {
      if (request === TypeOfRequest.LoadDashboard) {
        void dispatch(fetchDashboardThunk(val)).then((data: any) => {
          handleApiResponse(data, false);
        });
      } else if (request === TypeOfRequest.AllApplications) {
        void dispatch(fetchAllApplicantThunk(val)).then((data: any) => {
          handleApiResponse(data, false);
        });
      }
    }
  };

  const yearLabel =
    request === TypeOfRequest.LoadDashboard ? "Academic year" : "Year";

  const formatAcademicSpan = (y: number) =>
    `${y - 1}/${String(y).slice(-2)}`;

  return (
    <>
      {adminSelect.applicantState.applicationYears && (
        <>
          <MessageResponse feedback={feedback} />

          <FormControl size="small" sx={{ mr: 2 }} disabled={disabled}>
            <InputLabel id="demo-select-small">{yearLabel}</InputLabel>
            <Select
              name="applicationYear"
              labelId="demo-select-small"
              id="demo-select-small"
              label={yearLabel}
              value={String(internalSelected)}
              disabled={disabled}
              onChange={handleYearChange}
              sx={{
                '&.Mui-disabled': {
                  backgroundColor: 'rgba(0, 0, 0, 0.05)',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(0, 0, 0, 0.12)',
                  },
                  '& .MuiSelect-select': {
                    color: 'rgba(0, 0, 0, 0.38)',
                  }
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: disabled ? 'rgba(0, 0, 0, 0.12)' : 'rgba(0, 0, 0, 0.23)',
                },
              }}
            >
              <MenuItem value="" disabled>
                {yearLabel}
              </MenuItem>
              {adminSelect.applicantState.applicationYears.map(
                (y: number, index: number) => (
                  <MenuItem key={index} value={String(y)}>
                    {request === TypeOfRequest.LoadDashboard
                      ? formatAcademicSpan(y)
                      : y}
                  </MenuItem>
                )
              )}
            </Select>
          </FormControl>

         
        </>
      )}
    </>
  );
}
